import { render, staticRenderFns } from "./AddReferenceBtn.vue?vue&type=template&id=3b5b618a&"
import script from "./AddReferenceBtn.vue?vue&type=script&lang=js&"
export * from "./AddReferenceBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VHover,VIcon})
